import React, { useState } from "react"
import { Box } from "@mui/system"
import ButtonWithIcon from "src/v2/components/Button/Button"
import PropTypes from "prop-types"
import { ReactComponent as TableBaseIcon } from "src/v2/assets/icons/table-base-icon.svg"
import { Grid, ThemeProvider } from "@mui/material"
import ModalDialogPage from "src/components/modal-dialog"
import theme from "src/utils/theme"
import TableEmissaoCaracteristicas from "src/pages/emissao/tab/table/table_emissao_caracteristicas"

const ButtonIcon = ({ label, onClick }) => (
    <ButtonWithIcon icon={<TableBaseIcon />} onClick={onClick}>
        {label}
    </ButtonWithIcon>
)

ButtonIcon.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
}

export const BoxCreditEmissionButtonGroupAdmin = ({
    cetipIsin,
    callBackSetIsLoading,
}) => {
    const [openTableModal, setOpenTableModal] = useState({
        open: false,
        title: "",
        component: <></>,
    })

    const handleClickCharactersEmission = () => {
        setOpenTableModal({
            open: true,
            title: "Emissão Característica",
            component: (
                <TableEmissaoCaracteristicas
                    loading={callBackSetIsLoading}
                    cetipIsin={cetipIsin}
                />
            ),
        })
    }


    return (
        <div>
            <ThemeProvider theme={theme}>
                <ModalDialogPage
                    open={openTableModal.open}
                    title={openTableModal.title}
                    close={() => {
                        setOpenTableModal({
                            open: false,
                            component: null,
                            title: null,
                        })
                    }}
                >
                    <>
                        <Grid container direction="column">
                            <Grid item xs={12} md={12} xl={12}>
                                {openTableModal.component}
                            </Grid>
                        </Grid>
                    </>
                </ModalDialogPage>
            </ThemeProvider>
            <Box display="flex" gap={3} flexDirection="column">
                <Box
                    display="flex"
                    flexDirection={{ xxxs: "column", xs: "row" }}
                    flexWrap={{ xs: "wrap", md: "nowrap" }}
                    columnGap={{ xxxs: 3 }}
                    rowGap={{ xxxs: 2, md: 0 }}
                >
                    <ButtonIcon
                        label="EMISSÃO CARACTERISTICA"
                        onClick={handleClickCharactersEmission}
                    />

                </Box>
            </Box>
        </div>
    )
}

BoxCreditEmissionButtonGroupAdmin.propTypes = {
    cetipIsin: PropTypes.string.isRequired,
    callBackSetIsLoading: PropTypes.func,
}
